var $ = jQuery = require('jquery');
angular.module('blc').controller('RecentSearchController', RecentSearchController);
RecentSearchController.$inject = ['$scope', '$element', '$http', '$rootScope', 'quote', 'currency_srv'];
function RecentSearchController($scope, $element, $http, $rootScope, quote, currency_srv) {
  $scope.quote        = quote;
  $scope.quote_status = false;
  $scope.currency     = currency_srv;
  $scope.cars         = [];
  $scope.goto_search  = goto_search;
  $scope.length       = calculate_length;
  var that            = $scope;
  (function init() {
    return
    if (quote.id) {
      quote.recent_cars(3).then(function(data) { 
        $scope.cars = $.map(data.data, function(car) {
          return {
            name:        car.title,
            price:       car.price,
            image:       car.listing_image.image,
            description: car.listing_text,
            id:          car.id
          };
        });
      });
    } else {
      // take 3 from list

      $scope.cars = $.map($('ul.carlist li:lt(3)'), function(elm) {
        return {
          name:        $(elm).find('h3').text(),
          price:       elm.getAttribute('data-car-price'),
          image:       $(elm).find('img').attr('src'),
          description: $(elm).find('p').text(),
          id:          elm.getAttribute('data-car-name')
        };
      });

      // car page : show current + first 2 from list
      if (document.body.classList.contains('car_page')) {
        var current_car = jsonlddata[1];
        $scope.cars.unshift({
          description: current_car.description,
          price:       current_car.offers.price,
          image:       current_car.image,
          name:        current_car.name, 
          id:          current_car['@id']
        });
      }
    }
  })();
  $rootScope.$on('generic quote error', function() { $element.parent().removeClass('recent'); });
  function calculate_length() {
    if (!$scope.quote.dates[1]) return null;
    var hours = moment($scope.quote.dates[1]).diff(moment($scope.quote.dates[0]), 'hours');
    var days  = moment($scope.quote.dates[1]).diff(moment($scope.quote.dates[0]), 'days');
    return days < 1 ? hours + ' hours' : days + ' days';
  }
  function goto_search(car_id) {
    quote.car = car_id;
    quote.update();
    quote.goto_search();
    // $('.search-form:first .btn_search').click();
  }
}
angular.module('blc').filter('date_as_html', ['$sce','$filter', function($sce, $filter) {
  return function(val) {
    var day   = $filter('date')(val,'dd'),
        month = $filter('date')(val,'MMM'),
        week  = $filter('date')(val,'EEE');
    return $sce.trustAsHtml('<b>'+day+'</b><b><i>'+month+'</i><u>'+week+'</u></b>');
  }
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./gulp/assets/javascripts/recent-search-ctrl.js
 ** module id = 29
 ** module chunks = 0
 **/